// extracted by mini-css-extract-plugin
module.exports = {"cell":"cell___KfTXu","otherWrap":"other-wrap___3d1E5","valueWrap":"value-wrap___14v_3","valueItem":"value-item___1BC8_"};